import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import DefaultPage from './DefaultPage';
import Close from '../Icons/Close';
import styles from './DefaultPageModal.module.scss';

const DefaultPageModal = ({ show, onClose, openSongPage }) => {
  const handleOpenSong = useCallback(
    (songId) => {
      onClose();
      if (typeof openSongPage === 'function') {
        openSongPage(songId);
      }
    },
    [onClose, openSongPage]
  );

  useEffect(() => {
    if (!show) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.body.classList.add('default-page-modal-open');
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('default-page-modal-open');
    };
  }, [onClose, show]);

  if (!show) return null;

  const modalContent = (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="About Good Song Club"
    >
      <div className={styles.modal}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          <Close fill="#000" />
        </button>
        <div className={styles.body}>
          <DefaultPage openSongPage={handleOpenSong} />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default DefaultPageModal;
